var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FF5733",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582 4249 c-44 -13 -116 -86 -132 -134 -15 -44 -9 -119 12 -161 8 -17 359 -424 780 -905 569 -650 775 -879 803 -892 52 -25 113 -31 165 -17 40 11 76 43 305 271 l261 259 601 -692 601 -693 -206 -5 c-204 -5 -208 -5 -254 -33 -121 -71 -139 -227 -38 -328 70 -70 79 -71 605 -67 l450 3 45 25 c24 14 58 45 75 68 l30 44 0 502 0 503 -27 39 c-44 62 -90 88 -167 92 -82 4 -141 -23 -186 -87 l-30 -43 -5 -196 -5 -196 -634 730 c-710 816 -712 818 -763 845 -50 25 -129 25 -183 -1 -28 -14 -124 -105 -285 -271 -133 -137 -246 -249 -251 -247 -5 2 -295 332 -645 733 -350 402 -657 752 -683 779 -73 78 -148 101 -239 75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.88bc802decfcb12a30dbd722e33df224.svg";
export { ForwardRef as ReactComponent };